import React, { useContext } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import Button from "@/shared/components/Button/Button";
import { socialLogin } from "../../../api/login";
import { deviceMetadata } from "../../../tracking/tracking/getDeviceData";
import { navigateTo } from "../../utils/authUtils";

import Styles from "./SocialButton.module.scss";
import SVG from "@/shared/components/SVG/SVG";
import { delAfterLoginRedirectURL, getAfterLoginRedirectURL } from "../../../api/localStorage";
import { handleAuthSuccess } from "@/auth/utils/authUtils";
import AppContext from "@/App/context/AppContext";

interface props {
  type: "google" | "facebook";
  flags?: RegisterFlagsT;
  ctaId?: string;
  onSuccess?: () => void;
}

const SocialButton = ({ type, flags = {}, ctaId, onSuccess }: props) => {
  const { setLoggedIn } = useContext(AppContext);

  const handleUserLoginOrRegister = (platform: "google" | "facebook", accessToken: string) => {
    socialLogin(platform, accessToken, flags, {
      signInUrl: window.location.pathname,
      latestDeviceMetadata: deviceMetadata,
    })
      .then((response) => {
        // Dispach a custom event
        setLoggedIn?.(true);
        const customEvent = new CustomEvent("AuthEvent", { detail: { userId: response.user_id, platform } });
        window.dispatchEvent(customEvent);
        handleAuthSuccess();
        if (onSuccess) {
          onSuccess();
        } else {
          const urlAfterLogin = getAfterLoginRedirectURL();
          console.log("urlAfterLogin", urlAfterLogin);
          if (urlAfterLogin) {
            navigateTo(urlAfterLogin);
            delAfterLoginRedirectURL();
          } else {
            navigateTo("/");
          }
        }
      })
      .catch((error) => {
        throw error;
      });
  };
  const responseGoogle = ({ access_token }: { access_token: string }) => {
    try {
      handleUserLoginOrRegister("google", access_token);
    } catch (error) {
      console.log(error);
    }
  };

  const responseFacebook = (access_token: string) => {
    try {
      handleUserLoginOrRegister("facebook", access_token);
    } catch (error) {
      console.log(error);
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => responseGoogle(tokenResponse),
    onError: (error) => console.log("Google login failed, ", error),
  });

  const facebookLogin = () => {
    try {
      FB.login(
        function (response) {
          if (response.status === "connected") {
            responseFacebook(response.authResponse.accessToken);
          } else {
            console.log("could not login via facebook", response);
          }
        },
        { scope: "email, public_profile" }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const genericSocialLogin = () => {
    type === "google" ? googleLogin() : facebookLogin();
  };

  return (
    <Button fullWidth customColor className={Styles.SocialButton} onClick={() => genericSocialLogin()} id={ctaId}>
      <SVG name={type} />
      {type}
    </Button>
  );
};

export default SocialButton;
